import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ChevronDownIcon } from 'lucide-react';
import { SmartLink } from '../SmartLink';
import type { LegalNavItem } from '../../types/legal';
type LegalNavProps = {
  items: LegalNavItem[];
  current: string;
};
export function LegalNav({
  items,
  current
}: LegalNavProps) {
  const navigate = useNavigate();
  return <nav aria-label="Legal documents" className="print:hidden" data-id="element-719" data-mp="3o9ewpf6yj34a">
      {/* Desktop tabs */}
      <ul className="hidden gap-1 overflow-x-auto border-b border-canvas-line [scrollbar-width:none] lg:flex [&::-webkit-scrollbar]:hidden" data-id="element-720" data-mp="prj4toyedqgd">
        {items.map(item => {
        const active = item.slug === current;
        return <li key={item.slug} className="shrink-0" data-id="element-721" data-mp="b1btruapz9pp">
              <SmartLink href={`/legal/${item.slug}`} aria-current={active ? 'page' : undefined} className={`-mb-px block whitespace-nowrap border-b-2 px-3.5 py-3 text-[14px] font-medium transition-colors duration-150 ease-out ${active ? 'border-brand text-ink' : 'border-transparent text-ink-muted hover:text-ink'}`} data-id="element-722" data-mp="ayfrjtru9yvg">
                {item.label}
              </SmartLink>
            </li>;
      })}
      </ul>

      {/* Mobile dropdown */}
      <div className="relative lg:hidden" data-id="element-723" data-mp="wwh3mjd0m1nb">
        <label htmlFor="legal-nav-select" className="mb-1.5 block text-[13px] font-medium text-ink-muted" data-id="element-724" data-mp="wv5v668mk5pv">
          Legal document
        </label>
        <select id="legal-nav-select" value={current} onChange={e => navigate(`/legal/${e.target.value}`)} className="h-12 w-full appearance-none rounded-[10px] border border-ink/15 bg-white pl-4 pr-10 text-[16px] font-medium text-ink outline-none focus:border-brand" data-id="element-725" data-mp="mzcnb05up0ef">
          {items.map(item => <option key={item.slug} value={item.slug} data-id="element-726" data-mp="23bhyelqb0dsb">
              {item.label}
            </option>)}
        </select>
        <ChevronDownIcon className="pointer-events-none absolute bottom-4 right-3.5 h-4 w-4 text-ink-muted" aria-hidden="true" data-id="element-727" data-mp="25ya94qtzifq1" />
      </div>
    </nav>;
}